import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const getSchoolTemplatesQuery = gql`
  query getSchoolTemplates($id: ID!) {
    node(id: $id, type: CURRICULUM_PROGRAM) {
      ... on GenericCurriculumProgram {
        id
        transcriptTemplates {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getStudentsQuery = gql`
  query getStudents($ids: [ID!]!) {
    multiNode(ids: $ids, type: STUDENT) {
      ... on Student {
        ...userNameFields
        profileImage
      }
    }
  }
  ${userNameFragment}
`;
